import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef } from 'react';
import { renderVideoVOD } from '../../../shared/utils/VideoPlayer';

const useStyles = makeStyles(() => ({
  videoHtml: {
    outline: 'none',
  },
  playerStyle: {
    position: 'relative',
    width: '100%',
    color: '#fff',
  },
}));

const VideofilePlayer = (props) => {
  const classes = useStyles();
  const videoRef = useRef();
  const playerRef = useRef();

  useEffect(() => {
    if (playerRef.current && props.mux_asset_id) {
      playerRef.current.src(
        props.jwt
          ? `//stream.mux.com/${props.mux_asset_id}.m3u8?token=${props.jwt}`
          : `//stream.mux.com/${props.mux_asset_id}.m3u8`
      );
      playerRef.current.poster(
        `//image.mux.com/${props.mux_asset_id}/thumbnail.jpg?token=${props.thumb_jwt}`
      );
    } else {
      playerRef.current = renderVideoVOD(
        videoRef.current,
        props.mux_asset_id,
        props.jwt,
        props.thumb_jwt,
        null,
        null
      );
    }
    return () => {
      // Do we need to dispose or is React handling this?
      // Bug when disposing and going to another mux_asset_id
      // videoPlayerObject.dispose();
    };
  }, [props.mux_asset_id]);

  return (
    <Box className={classes.playerStyle}>
      <video
        className={`${classes.videoHtml} video-js vjs-big-play-centered`}
        ref={videoRef}
        controls
        playsInline
      >
        <source
          src={`//stream.mux.com/${props.mux_asset_id}.m3u8${
            props.jwt ? `?token=${props.jwt}` : ''
          }`}
          type="application/x-mpegURL"
        />
      </video>
    </Box>
  );
};

export default VideofilePlayer;
